import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};
export const BothMarketIcon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
      >
        <g clipPath="url(#clip0_1087_476)">
          <path
            d="M2.90625 14.7588H6.96875M2.90625 5.27962V5.95671C2.90625 6.49543 3.12026 7.01208 3.50119 7.39302C3.88212 7.77395 4.39878 7.98796 4.9375 7.98796C5.47622 7.98796 5.99288 7.77395 6.37381 7.39302C6.75474 7.01208 6.96875 6.49543 6.96875 5.95671M2.90625 5.27962H15.0938M2.90625 5.27962L4.26042 2.57129H13.7396L15.0938 5.27962M6.96875 5.95671V5.27962M6.96875 5.95671C6.96875 6.49543 7.18276 7.01208 7.56369 7.39302C7.94462 7.77395 8.46128 7.98796 9 7.98796C9.53872 7.98796 10.0554 7.77395 10.4363 7.39302C10.8172 7.01208 11.0312 6.49543 11.0312 5.95671M11.0312 5.95671V5.27962M11.0312 5.95671C11.0312 6.49543 11.2453 7.01208 11.6262 7.39302C12.0071 7.77395 12.5238 7.98796 13.0625 7.98796C13.6012 7.98796 14.1179 7.77395 14.4988 7.39302C14.8797 7.01208 15.0937 6.49543 15.0938 5.95671V5.27962M4.26042 14.7589V7.88646M13.7396 9.07129V7.88646M6.96875 14.7588V12.0505C6.96875 11.6913 7.11142 11.3469 7.36538 11.0929C7.61933 10.839 7.96377 10.6963 8.32292 10.6963H9.67708C10.0362 10.6963 10.3807 10.839 10.6346 11.0929C10.8886 11.3469 11.0312 11.6913 11.0312 12.0505V14.7588H6.96875Z"
            stroke="#1A1721"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.0781 15.8421V15.8489M14.0781 13.8107C14.3817 13.8097 14.6761 13.707 14.9143 13.5189C15.1525 13.3307 15.3207 13.0681 15.392 12.7731C15.4633 12.4781 15.4336 12.1676 15.3076 11.8915C15.1816 11.6153 14.9666 11.3895 14.697 11.25C14.4276 11.112 14.1195 11.0692 13.8227 11.1286C13.526 11.188 13.258 11.346 13.0625 11.577"
            stroke="#1A1721"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1087_476">
            <rect
              width="16.25"
              height="16.25"
              fill="white"
              transform="translate(0.875 0.540039)"
            />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
